var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70.812 96.961",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -278.9 1025.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(693.71 -293.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-482.69 991.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v55.927h12.031c0.507 0 0.921 0.415 0.921 0.921v12.188h36.472v-69.036zm11.11 67.71v-9.94h-9.82zm39.235 3.169h-38.314c-0.129 0-0.249-0.028-0.359-0.074-0.111-0.046-0.212-0.111-0.295-0.203h-9e-3l-12.943-13.099c-0.028-0.037-0.046-0.083-0.074-0.12-0.046-0.056-0.092-0.111-0.12-0.175-0.046-0.111-0.073-0.231-0.073-0.36l-1e-3 -57.769c0-0.507 0.415-0.921 0.922-0.921h52.187v71.799c0 0.507-0.415 0.922-0.921 0.922",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-475.2 1028.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h36.297c0.509 0 0.921 0.412 0.921 0.921s-0.412 0.921-0.921 0.921h-36.297c-0.509 0-0.921-0.412-0.921-0.921s0.412-0.921 0.921-0.921",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-439.14 1002.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-36.052c-0.51 0-0.922-0.412-0.922-0.921s0.412-0.921 0.922-0.921h36.052c0.509 0 0.921 0.412 0.921 0.921s-0.412 0.921-0.921 0.921",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-439.02 1009.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-36.173c-0.509 0-0.921-0.412-0.921-0.921s0.412-0.921 0.921-0.921h36.173c0.509 0 0.921 0.412 0.921 0.921s-0.412 0.921-0.921 0.921",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-438.9 1016.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-36.297c-0.509 0-0.921-0.412-0.921-0.921s0.412-0.921 0.921-0.921h36.297c0.509 0 0.921 0.412 0.921 0.921s-0.412 0.921-0.921 0.921",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-475.2 1021.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h36.297c0.509 0 0.921 0.412 0.921 0.921s-0.412 0.921-0.921 0.921h-36.297c-0.509 0-0.921-0.412-0.921-0.921s0.412-0.921 0.921-0.921",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-475.2 1035.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h21.018c0.509 0 0.921 0.412 0.921 0.921s-0.412 0.921-0.921 0.921h-21.018c-0.509 0-0.921-0.412-0.921-0.921s0.412-0.921 0.921-0.921",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-446.16 1052.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.596-0.031-1.192-9e-3 -1.788-9e-3 -0.152-4e-3 -0.303 0-0.518 0v2.734c0.833 0 1.637 0.054 2.432-0.015 0.88-0.076 1.316-0.612 1.281-1.404-0.032-0.763-0.546-1.259-1.407-1.306m5.148-6.858c-0.293 0.414-0.353 0.701-0.019 1.149 0.826 1.113 1.584 2.277 2.366 3.425 0.132 0.193 0.255 0.395 0.435 0.669l6e-3 0.01h-0.867c-0.151-4e-3 -0.3-4e-3 -0.448 0h-1.095l-0.766-1.228c-0.372-0.574-0.76-1.151-1.155-1.76-0.719 1.054-1.391 2.035-2.078 3.041 0.132 0.076 0.214 0.123 0.296 0.167 1.363 0.751 1.953 1.962 1.682 3.476-0.253 1.414-1.228 2.385-2.792 2.486-1.685 0.107-3.385 0.025-5.11 0.025v-9.498h2.082v3.026c0.337 0 0.627-0.032 0.908 6e-3 0.48 0.066 0.77-0.114 1.032-0.524 0.763-1.183 1.558-2.343 2.372-3.492 0.23-0.325 0.214-0.542-0.013-0.854-0.505-0.682-0.968-1.395-1.448-2.095-0.505-0.738-1.012-1.479-1.605-2.344 0.684 0 1.236 0.032 1.782-9e-3 0.467-0.038 0.732 0.142 0.971 0.533 0.565 0.912 1.174 1.795 1.805 2.747 0.659-1.003 1.268-1.936 1.889-2.864 0.101-0.151 0.253-0.372 0.388-0.378 0.735-0.038 1.473-0.019 2.325-0.019-1.028 1.514-1.965 2.924-2.943 4.305",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPi);
export default __webpack_public_path__ + "static/media/pi.818c32b9dcf483de6bda262a5aa7ad9b.svg";
export { ForwardRef as ReactComponent };